<template>
  <div class="tag-picker">
    <div class="tag-picker__workspace">
      <div class="tag-picker__toolbar">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索分类"
          size="mini"
          clearable
          class="tag-picker__search"
          prefix-icon="el-icon-search"
          @input="debounceSearch"
        />
      </div>

      <button
        type="button"
        class="tag-picker__selectedDock"
        :class="{
          'tag-picker__selectedDock--active': selectedOverlayOpen,
          'tag-picker__selectedDock--empty': !selectedNames.length,
        }"
        :disabled="!selectedNames.length"
        @click="toggleSelectedOverlay"
      >
        <i class="el-icon-folder-opened" aria-hidden="true" />
        <span class="tag-picker__selectedDockText">
          <template v-if="selectedNames.length">
            已选分类 · {{ selectedNames.length }} 个
          </template>
          <template v-else>点击下方卡片选择分类</template>
        </span>
        <span v-if="selectedNames.length" class="tag-picker__selectedDockAction">
          {{ selectedOverlayOpen ? '收起' : '查看' }}
        </span>
      </button>

      <div class="tag-picker__scrollWrap">
        <div class="tag-picker__scroll" @wheel="handleScrollWheel">
          <div v-if="filteredNames.length" class="tag-picker__l1">
            <div class="tag-picker__cardGrid">
              <button
                v-for="name in filteredNames"
                :key="name"
                type="button"
                class="tag-picker__l1Card"
                :class="{ 'tag-picker__l1Card--selected': isSelected(name) }"
                @click="toggleName(name)"
              >
                <span class="tag-picker__l1CardTop">
                  <span class="tag-picker__l1CardKind">分类</span>
                  <span v-if="isSelected(name)" class="tag-picker__l1CardBadge">已选</span>
                </span>
                <span class="tag-picker__l1CardName">{{ name }}</span>
              </button>
            </div>
          </div>
          <el-empty
            v-else
            description="未找到匹配的分类"
            :image-size="48"
            class="tag-picker__empty"
          />
        </div>

        <transition name="tag-picker-selected-sheet">
          <div
            v-if="selectedOverlayOpen && selectedNames.length"
            class="tag-picker__selectedLayer"
            role="dialog"
            aria-modal="true"
            aria-label="已选分类"
          >
            <div class="tag-picker__selectedPanel">
              <div class="tag-picker__selectedPanelHead">
                <span class="tag-picker__selectedPanelTitle">
                  已选分类 · {{ selectedNames.length }} 个
                </span>
                <button
                  type="button"
                  class="tag-picker__selectedCloseBtn"
                  @click="closeSelectedOverlay"
                >
                  收起
                </button>
              </div>
              <div class="tag-picker__selectedChips">
                <el-tag
                  v-for="name in selectedNames"
                  :key="name"
                  closable
                  size="mini"
                  class="tag-picker__selectedChip"
                  @close="removeName(name)"
                >
                  {{ name }}
                </el-tag>
              </div>
            </div>
            <div
              class="tag-picker__selectedBackdrop"
              aria-hidden="true"
              @click="closeSelectedOverlay"
              @wheel.prevent
            />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllCategory } from '../../../../api/comment'

/**
 * 创建/编辑 · 分类多选器（扁平列表）。
 * 视觉与 batchTag/tagPicker 一致：搜索 + 已选 dock + 三列卡片多选。
 */
export default {
  name: 'LinkCategoryPicker',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    /** 分类业务 type，通用资源为 21 */
    categoryType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searchKeyword: '',
      allNames: [],
      selectedNames: [...this.value],
      timer: null,
      selectedOverlayOpen: false,
    }
  },
  computed: {
    filteredNames() {
      const keyword = this.searchKeyword.trim().toLowerCase()
      if (!keyword) {
        return this.allNames
      }
      return this.allNames.filter((name) => name.toLowerCase().includes(keyword))
    },
  },
  watch: {
    value(next) {
      this.selectedNames = [...next]
    },
  },
  created() {
    this.loadCategories()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    loadCategories() {
      getAllCategory(this.searchKeyword, this.categoryType).then((res) => {
        if (res.success) {
          this.allNames = (res.data || []).map((item) => item.name)
        }
      })
    },
    debounceSearch() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.loadCategories()
      }, 200)
    },
    isSelected(name) {
      return this.selectedNames.includes(name)
    },
    toggleName(name) {
      const index = this.selectedNames.indexOf(name)
      if (index >= 0) {
        this.selectedNames.splice(index, 1)
      } else {
        this.selectedNames.push(name)
      }
      this.emitChange()
    },
    removeName(name) {
      this.selectedNames = this.selectedNames.filter((item) => item !== name)
      if (!this.selectedNames.length) {
        this.selectedOverlayOpen = false
      }
      this.emitChange()
    },
    toggleSelectedOverlay() {
      if (!this.selectedNames.length) {
        return
      }
      this.selectedOverlayOpen = !this.selectedOverlayOpen
    },
    closeSelectedOverlay() {
      this.selectedOverlayOpen = false
    },
    emitChange() {
      this.$emit('input', [...this.selectedNames])
      this.$emit('change', [...this.selectedNames])
    },
    handleScrollWheel(event) {
      const el = event.currentTarget
      if (!el) {
        return
      }
      const delta = event.deltaY
      const atTop = el.scrollTop <= 0
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1
      if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
        event.preventDefault()
      }
      event.stopPropagation()
    },
  },
}
</script>

<style src="./pickerShared.css"></style>
